<template>
    <div class="factory-research-faults">
        <el-row class="factory-research-fault-title">
            <el-col :span="3">
                <span class="h3">异常库</span>
            </el-col>
            <el-col :span="6" :offset="13">
                <div class="factory-research-fault-title-filter">
                    <span class="label">异常搜索：</span>
                    <el-input placeholder="请输入异常名称" prefix-icon="el-icon-search"></el-input>
                </div>
            </el-col>
            <el-col :span="2">
                <span class="btn-add" @click="handAddFaultProtocol"> <i class="iconfont icon-tianjia1"></i> 新增异常</span>
            </el-col>
        </el-row>

        <div class="factory-research-fault-data-list">
            <el-table :data="faultProtocols">
                <el-table-column label="编号" align="center" prop="phone"></el-table-column>
                <el-table-column label="名称" align="center" prop="groupName"></el-table-column>
                <el-table-column label="通知类型" align="center" prop="registerAt"></el-table-column>
                <el-table-column label="异常类型" align="center" prop="name"></el-table-column>
                <el-table-column label="处理办法" align="center" prop="name"></el-table-column>
                <el-table-column :label="$t('cao_zuo')" align="center" prop="name">
                    <template slot-scope="scope">
                        <span @click="handleEditFaultProtocol(scope.row, scope.$index)"
                              class="research-fault-edit">{{$t('bian_ji')}}</span>
                        <span @click="handleDelete(scope.row, scope.$index)" class="research-fault-delete">{{$t('shan_chu')}}</span>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                    class="pagination"
                    :current-page="currentPage"
                    :page-size="100"
                    layout="total, prev, pager, next, jumper"
                    :total="400">
            </el-pagination>
        </div>

        <c-dialog class="dialog" :visible.sync="addFaultProtocolVisible" :width="'36rem'" :height="'24rem'"
                  title="新增异常协议">
            <el-form class="create-protocol-dialog" label-width="80px">
                <el-form-item label="异常名称">
                    <el-input v-model="faultProtocol.name" placeholder="请输入异常名称"></el-input>
                </el-form-item>
                <el-form-item label="异常等级">
                    <el-select
                            placeholder="请选择异常等级" v-model="faultProtocol.level">
                        <el-option v-for="item in faultLevelOptions"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value"></el-option>

                    </el-select>
                </el-form-item>
                <el-form-item label="异常类型">
                    <el-input v-model="faultProtocol.faultType" placeholder="请输入异常类型"></el-input>
                </el-form-item>
                <el-form-item label="解决办法">
                    <el-input v-model="faultProtocol.remark" type="textarea" :rows="3" placeholder="异常解决办法"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button class="success" plain @click="faultProtocolCreate">{{$t('ti_jiao')}}</el-button>
                </el-form-item>
            </el-form>
        </c-dialog>
        <c-dialog class="dialog" :visible.sync="editFaultProtocolVisible" title="编辑异常协议">
            <el-form class="create-protocol-dialog" label-width="100px">
                <el-form-item label="异常名称">
                    <el-input v-model="faultProtocol.name"></el-input>
                </el-form-item>
                <el-form-item label="异常等级">
                    <el-select
                            placeholder="请选择" v-model="faultProtocol.level">
                        <el-option v-for="item in faultLevelOptions"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value"></el-option>

                    </el-select>
                </el-form-item>
                <el-form-item label="异常类型">
                    <el-input v-model="faultProtocol.faultType"></el-input>
                </el-form-item>
                <el-form-item label="解决办法">
                    <el-input v-model="faultProtocol.remark" type="textarea" :rows="3"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button class="success" plain @click="faultProtocolUpdate">{{$t('ti_jiao')}}</el-button>
                </el-form-item>
            </el-form>
        </c-dialog>


    </div>

</template>

<script>
//    import avatar from '@/assets/img/avatar.jpg'
    import CDialog from '@/components/Dialog'
    import {
        faultList,
        faultCreate,
        faultUpdate
    } from '@/api/factory/research/fault';
    export default {
        name: '',
        components: {
            CDialog
        },
        mounted: function () {
        },
        data: function () {
            return {
                faultProtocols: [],
                currentPage: 1,
                addFaultProtocolVisible: false,
                editFaultProtocolVisible: false,
                faultProtocol: {
                    uuid: '',
                    productUuid: '',
                    name: '',
                    level: '',
                    faultType: '',
                    remark: ''
                },
                faultLevelOptions: [
                    {label: '普通通知', value: 0},
                    {label: '媒体通讯通知', value: 1},
                    {label: '短信通知', value: 2},
                    {label: '语音电话通知', value: 3},
                    {label: '强制通知', value: 4},
                ],
            }
        },
        filters: {
            faultLevel (type){
                switch (type) {
                    case 0:
                        return `普通通知`
                    case 1:
                        return `媒体通讯通知`
                    case 2:
                        return `短信通知`
                    case 3:
                        return `语音电话通知`
                    case 4:
                        return `强制通知`
                }
                return `未知通知`
            }
        },
        methods: {
            handleDelete (){

            },

            handAddFaultProtocol(){
                this.faultProtocol = {
                    uuid: '',
                    productUuid: '',
                    name: '',
                    level: 0,
                    faultType: '',
                    remark: ''
                }
                this.addFaultProtocolVisible = true
            },

            handleEditFaultProtocol(data){
                this.faultProtocol = data
                this.editFaultProtocolVisible = true
            },

            loadProductFaultProtocol(){
                let vue = this
                if (vue.faultProtocols.length === 0) {
                    faultList(this.products[this.clickIndex].uuid).then(res => {
                        if (res !== null && res.code === 0) {
                            vue.faultProtocols = res.data || []
                        }
                    })
                }
            },

            faultProtocolCreate(){
                if (this.faultProtocol.name === ``) {
                    this.$message.error('请输入异常名称')
                    return
                }
                if (this.faultProtocol.faultType === ``) {
                    this.$message.error('请输入异常类型')
                    return
                }

                if (this.faultProtocol.remark === ``) {
                    this.$message.error('请输入解决办法')
                    return
                }

                let data = {
                    productUuid: this.products[this.clickIndex].uuid,
                    name: this.faultProtocol.name,
                    level: parseInt(this.faultProtocol.level),
                    faultType: this.faultProtocol.faultType,
                    remark: this.faultProtocol.remark,
                }


                let vue = this
                faultCreate(data).then(res => {
                    if (res !== null && res.code === 0) {
                        data.uuid = res.data
                        vue.faultProtocols.push(data)
                        vue.addFaultProtocolVisible = false
                    }
                })

            },

            faultProtocolUpdate(){
                if (this.faultProtocol.name === ``) {
                    this.$message.error('请输入异常名称')
                    return
                }
                if (this.faultProtocol.faultType === ``) {
                    this.$message.error('请输入异常类型')
                    return
                }

                if (this.faultProtocol.remark === ``) {
                    this.$message.error('请输入解决办法')
                    return
                }


                let vue = this
                faultUpdate(this.faultProtocol).then(res => {
                    if (res !== null && res.code === 0) {
                        vue.faultProtocol = {
                            uuid: '',
                            productUuid: '',
                            name: '',
                            level: '',
                            faultType: '',
                            remark: ''
                        }
                        vue.editFaultProtocolVisible = false
                    }
                })

            },

        },
    }
</script>

<style lang="scss">
    .factory-research-faults {
        padding: $padding $t-padding;
        display: flex;
        flex-direction: column;
        .factory-research-fault-title {
            margin-bottom: $padding;
            .factory-research-fault-title-filter {
                display: flex;
                justify-content: center;
                align-items: center;
                .label {
                    display: inline-block;
                    width: 5rem;
                    font-size: .6rem;
                    color: $f_sec_color;
                    text-align: right;
                }
            }
            .el-input {
                .el-input__inner {
                    height: 24px;
                    line-height: 24px;
                }
                .el-input__icon {
                    line-height: 24px;
                }
            }
            .btn-add {
                margin-left: $padding-5;
                color: $f_color;
                font-size: .6rem;
                padding: $padding-3;
                border-radius: .3rem;
                cursor: pointer;
            }
            .btn-add:hover {
                background-color: $bg_six_color;
                font-weight: $w1;
            }
        }

        .factory-research-fault-data-list {
            flex: 1;
            border-radius: .5rem;
            // background-color: $bg_sec_color;
            padding: $padding;
            .research-fault-edit, .research-fault-delete {
                cursor: pointer;
                display: inline-block;
                margin-right: $padding;
            }
            .research-fault-edit {
                color: $btn_color;
            }
            .research-fault-delete {
                color: $btn_sec_color;
            }

            .pagination {
                margin-top: $padding;
            }
        }

        .dialog {
            .create-protocol-dialog {
                padding: 0 $padding;
                .el-form-item__label {
                    color: $f_sec_color;
                }
                .el-textarea__inner, .el-input__inner {
                    border-color: $bg_999_color;
                    color: $f_th_color;
                }

                .el-textarea__inner {
                    font-size: .6rem;
                }

                .el-button {
                    color: $f_color;
                }

                .protocol-input {
                    p {
                        margin-top: 5px;
                        font-size: 12px;
                        color: #999999;
                    }
                }
            }
        }
    }

</style>
